import { trackEvent } from '@pb/utils'

import { PAGE_IDS } from './helpers/getAccountTrackingData'

const myAccountCategory = 'myAccount'

const baseAccountClickData = {
  event_category: myAccountCategory,
}

const myAccountBaseData = {
  eventCategory: myAccountCategory,
}

const alternativeIdsBaseData = {
  eventCategory: myAccountCategory,
  eventType: 'ALTERNATIVE_ID',
}

export const challengesPageEntry = (label?: string): void => {
  trackEvent({
    event_id: label,
    event_type: `challenges`,
    event_category: 'challengesPageEntry',
  })
}
export const challengesPage = (label?: string): void => {
  trackEvent({
    event_id: label,
    event_type: `challenges`,
    event_category: 'challengesPage',
  })
}

export const ACCOUNT_TRACKING_EVENTS = {
  // Menu click events
  pointsHistoryEntry: {
    ...baseAccountClickData,
    event_id: 'pointsHistoryEntry',
    event_type: `${myAccountCategory}/pointsHistoryEntry`,
  },
  inviteAFriendFromMenu: {
    ...baseAccountClickData,
    event_id: 'inviteAFriendFromMenu',
    event_type: `${myAccountCategory}/inviteAFriendFromMenu`,
  },
  allPurchases: {
    ...baseAccountClickData,
    event_id: 'allPurchases',
    event_type: `${myAccountCategory}/allPurchases`,
  },
  paymentSettingsFromMenu: {
    ...baseAccountClickData,
    event_id: 'paymentSettingsFromMenu',
    event_type: `${myAccountCategory}/paymentSettingsFromMenu`,
  },
  settingsFromMenu: {
    ...baseAccountClickData,
    event_id: 'settingsFromMenu',
    event_type: `${myAccountCategory}/settingsFromMenu`,
  },
  ratingsFromMenu: {
    ...baseAccountClickData,
    event_id: 'ratingsFromMenu',
    event_type: `${myAccountCategory}/ratingsFromMenu`,
  },
  myStyleCornerFromMenu: {
    ...baseAccountClickData,
    event_id: 'myStyleCornerFromMenu',
    event_type: `${myAccountCategory}/myStyleCornerFromMenu`,
  },
  aboutMembersshipFromMenu: {
    ...baseAccountClickData,
    event_id: 'aboutMembersshipFromMenu',
    event_type: `${myAccountCategory}/aboutMembersshipFromMenu`,
  },
  contactUsFromMenu: {
    ...baseAccountClickData,
    event_id: 'contactUsFromMenu',
    event_type: `${myAccountCategory}/contactUsFromMenu`,
  },
  signOutFromMenu: {
    ...baseAccountClickData,
    event_id: 'signOutFromMenu',
    event_type: `${myAccountCategory}/signOutFromMenu`,
  },
  // New User Menu click events
  pointsHistoryUserEntry: {
    ...baseAccountClickData,
    event_id: 'pointshistoryentry',
    event_type: `${myAccountCategory}/pointshistoryentry`,
  },
  inviteAFriendEntry: {
    ...baseAccountClickData,
    event_id: 'inviteafriendentry',
    event_type: `${myAccountCategory}/inviteafriendentry`,
  },
  allPurchasesEntry: {
    ...baseAccountClickData,
    event_id: 'allpurchasesentry',
    event_type: `${myAccountCategory}/allpurchasesentry`,
  },
  paymentSettingsEntry: {
    ...baseAccountClickData,
    event_id: 'paymentSettingsEntry',
    event_type: `${myAccountCategory}/paymentsettingsentry`,
  },
  settingsEntry: {
    ...baseAccountClickData,
    event_id: 'settingsentry',
    event_type: `${myAccountCategory}/settingsentry`,
  },
  rateAndReviewEntry: {
    ...baseAccountClickData,
    event_id: 'rateandreviewentry',
    event_type: `${myAccountCategory}/rateandreviewentry`,
  },
  helpUsImproveEntry: {
    ...baseAccountClickData,
    event_id: 'helpusimproveentry',
    event_type: `${myAccountCategory}/helpusimproveentry`,
  },
  payLaterEntry: {
    ...baseAccountClickData,
    event_id: 'paylaterentry',
    event_type: `${myAccountCategory}/paylaterentry`,
  },
  aboutMembersshipEntry: {
    ...baseAccountClickData,
    event_id: 'aboutmembersshipentry',
    event_type: `${myAccountCategory}/aboutmembersshipentry`,
  },
  contactUsEntry: {
    ...baseAccountClickData,
    event_id: 'contactusentry',
    event_type: `${myAccountCategory}/contactusentry`,
  },
  signout: {
    ...baseAccountClickData,
    event_id: 'signout',
    event_type: `${myAccountCategory}/signout`,
  },
  /* Help Us Improve tracks */
  submitFeedbackBtn: {
    ...baseAccountClickData,
    event_id: 'huifeedbacksubmitsuccess',
    event_type: `${myAccountCategory}/huifeedbacksubmitsuccess`,
  },

  ratingStarsFeedback: {
    ...baseAccountClickData,
    event_id: 'huifeedbacksubmitclick',
    event_type: `${myAccountCategory}/huifeedbacksubmitclick`,
  },

  /* End of help Us Improve tracks */

  //  Start Payments
  paymentEditBankAccountCTAClicked: {
    ...baseAccountClickData,
    event_id: 'paymentEditBankAccountCTAClicked',
    event_type: `${myAccountCategory}/paymentEditBankAccountCTAClicked`,
  },
  paymentEditBankAccountSuccess: {
    ...baseAccountClickData,
    event_id: 'paymentEditBankAccountSuccess',
    event_type: `${myAccountCategory}/paymentEditBankAccountSuccess`,
  },
  paymentEditBankAccountFail: {
    ...baseAccountClickData,
    event_id: 'paymentEditBankAccountFail',
    event_type: `${myAccountCategory}/paymentEditBankAccountFail`,
  },
  paymentRemoveBankAccountCTAClicked: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveBankAccountCTAClicked',
    event_type: `${myAccountCategory}/paymentRemoveBankAccountCTAClicked`,
  },
  paymentRemoveBankAccountConfirmationBoxOK: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveBankAccountConfirmationBoxOK',
    event_type: `${myAccountCategory}/paymentRemoveBankAccountConfirmationBoxOK`,
  },
  paymentRemoveBankAccountSuccess: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveBankAccountSuccess',
    event_type: `${myAccountCategory}/paymentRemoveBankAccountSuccess`,
  },
  paymentRemoveBankAccountFail: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveBankAccountFail',
    event_type: `${myAccountCategory}/paymentRemoveBankAccountFail`,
  },
  paymentRemoveSavedCardCTAClicked: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveSavedCardCTAClicked',
    event_type: `${myAccountCategory}/paymentRemoveSavedCardCTAClicked`,
  },
  paymentRemoveSavedCardConfirmationBoxOK: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveSavedCardConfirmationBoxOK',
    event_type: `${myAccountCategory}/paymentRemoveSavedCardConfirmationBoxOK`,
  },
  paymentRemoveSavedCardSuccess: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveSavedCardSuccess',
    event_type: `${myAccountCategory}/paymentRemoveSavedCardSuccess`,
  },
  paymentRemoveSavedCardFail: {
    ...baseAccountClickData,
    event_id: 'paymentRemoveSavedCardFail',
    event_type: `${myAccountCategory}/paymentRemoveSavedCardFail`,
  },
  paymentChangedDefaultCardSelection: {
    ...baseAccountClickData,
    event_id: 'paymentChangedDefaultCardSelection',
    event_type: `${myAccountCategory}/paymentChangedDefaultCardSelection`,
  },
  paymentAddPcmiSuccess: {
    ...baseAccountClickData,
    event_type: `${myAccountCategory}/paymentAddPCMISuccess`,
    event_id: 'paymentAddPCMISuccess',
  },
  paymentAddPCMIFail: {
    ...baseAccountClickData,
    event_type: `${myAccountCategory}/paymentAddPCMIFail`,
    event_id: 'paymentAddPCMIFail',
  },
  paymentDeletePCMISuccess: {
    ...baseAccountClickData,
    event_type: `${myAccountCategory}/paymentDeletePCMISuccess`,
    event_id: 'paymentDeletePCMISuccess',
  },
  paymentDeletePCMIFail: {
    ...baseAccountClickData,
    event_type: `${myAccountCategory}/paymentDeletePCMIFail`,
    event_id: 'paymentDeletePCMIFail',
  },
  paymentOpenPCMIInformationModal: {
    ...baseAccountClickData,
    event_type: `${myAccountCategory}/paymentOpenPCMIInformationModal`,
    event_id: 'paymentOpenPCMIInformationModal',
  },
  paymentOpenNewCardForm: {
    ...baseAccountClickData,
    event_type: `${myAccountCategory}/paymentOpenNewCardForm`,
    event_id: 'paymentOpenNewCardForm',
  },
  paymentClickChangeBillingAdress: {
    ...baseAccountClickData,
    event_id: 'paymentClickChangeBillingAdress',
    event_type: `${myAccountCategory}/paymentClickChangeBillingAdress`,
  },
  paymentAddNewCardSuccess: {
    ...baseAccountClickData,
    event_id: 'paymentAddNewCardSuccess',
    event_type: `${myAccountCategory}/paymentAddNewCardSuccess`,
  },
  paymentAddNewCardFail: {
    ...baseAccountClickData,
    event_id: 'paymentAddNewCardFail',
    event_type: `${myAccountCategory}/paymentAddNewCardFail`,
  },
  paymentOpenBillingAddressModal: {
    ...baseAccountClickData,
    event_id: 'paymentOpenBillingAddressModal',
    event_type: `${myAccountCategory}/paymentOpenBillingAddressModal`,
  },
  paymentClickAddBillingAdress: {
    ...baseAccountClickData,
    event_id: 'paymentClickAddBillingAdress',
    event_type: `${myAccountCategory}/paymentClickAddBillingAdress`,
  },
  //  End Payments
  onRewearClick: {
    ...myAccountBaseData,
    eventId: 'ClickResellItem',
    eventType: `${myAccountCategory}/ClickResellItem`,
  },
  onRewearAboutClick: {
    ...myAccountBaseData,
    eventId: 'ClickAboutRewear',
    eventType: `${myAccountCategory}/ClickAboutRewear`,
  },
  onReturnCTAClicked: {
    ...baseAccountClickData,
    event_id: 'clickReturnAnItem',
    event_type: `${myAccountCategory}/clickReturnAnItem`,
  },
  onTrackOrderCTAClicked: {
    ...baseAccountClickData,
    event_id: 'clickTrackOrder',
    event_type: `${myAccountCategory}/clickTrackOrder`,
  },
  onRateAndReviewCTAClicked: {
    ...baseAccountClickData,
    event_id: 'clickRateAndReviewInOrder',
    event_type: `${myAccountCategory}/clickRateAndReviewInOrder`,
  },
  onPromotionCodeClick: {
    ...myAccountBaseData,
    eventId: 'redeemPromotioncode',
    eventType: `${myAccountCategory}/redeemPromotioncode`,
  },
  purchasedProductClick: {
    ...myAccountBaseData,
    eventId: 'orderProductClick',
    eventType: `${myAccountCategory}/orderProductClick`,
  },
  onActiveOrdersClick: {
    ...myAccountBaseData,
    eventType: `${myAccountCategory}/orderStatusWidget`,
    eventId: 'orderStatusWidget',
  },
  onNewsClick: {
    ...myAccountBaseData,
    eventType: `${myAccountCategory}/Newswidget`,
    eventId: 'Newswidget',
  },
  onOrderItemClick: {
    ...myAccountBaseData,
    eventId: 'allpurchasesorderclick',
    eventType: `${myAccountCategory}/allpurchasesorderclick`,
  },
  onKlarnaOrderItemClick: {
    ...myAccountBaseData,
    eventId: 'purchasesKlarnaFromOrders',
    eventType: `${myAccountCategory}/onlineOrdersList`,
  },
  onKlarnaInvoicesMenuLinkClick: {
    event_category: myAccountCategory,
    event_id: 'purchasesKlarnaFromMenu',
    event_type: myAccountCategory,
  },
  onKlarnaInvoicesOrderDetails: {
    ...myAccountBaseData,
    eventId: 'purchasesKlarnaFromOrderDetails',
    eventType: `${myAccountCategory}/onlineOrdersList/orderDetails`,
  },
  onPayLaterActivationCardClick: {
    ...myAccountBaseData,
    eventId: 'Pay later CTA link clicked',
    eventType: `${myAccountCategory}/PAY_LATER_CTA_CLICK`,
  },
  onPayLaterActivationClick: {
    ...myAccountBaseData,
    eventId: 'Pay later Banner CTA link clicked',
    eventType: `${myAccountCategory}/PAY_LATER_CTA_CLICK`,
  },
  accountPageView: {
    id: 'accountPageView',
    data: {
      page_id: PAGE_IDS.account,
    },
  },
  purchasesPageView: {
    id: 'purchasesPageView',
    data: {
      page_id: PAGE_IDS.purchases,
    },
  },
  helpUsImprovePageView: {
    pageId: PAGE_IDS.helpus,
    data: {
      event_type: 'FEEDBACK_WIDGET_VIEW',
      dep_variable_name: ['feedback_team'],
      dep_variable_format: ['string'],
    },
  },
  purchasesKlarnaPageView: {
    id: 'purchasesKlarnaPageView',
    data: {
      page_id: PAGE_IDS.purchasesKlarna,
    },
  },
  personalSettingsPageView: {
    id: 'personalSettingsPageView',
    data: {
      page_id: PAGE_IDS.settings,
    },
  },
  pointsHistoryPageView: {
    id: 'pointsHistoryPageView',
    data: {
      page_id: PAGE_IDS.pointsHistory,
    },
  },
  onCancellationModalClick: {
    ...myAccountBaseData,
    eventId: 'openordercancellation',
    eventType: `${myAccountCategory}/openordercancellation`,
  },
  inviteFriendPageView: {
    id: 'inviteFriendPageView',
    data: {
      page_id: PAGE_IDS.inviteFriend,
    },
  },
  inviteFriendInfoPageView: {
    id: 'inviteFriendInfoPageView',
    data: {
      page_id: PAGE_IDS.inviteFriendInfo,
    },
  },
  alternativeIdsPageView: {
    pageId: PAGE_IDS.alternativeIds,
    data: {
      event_category: myAccountCategory,
      event_type: 'ALTERNATIVE_ID',
    },
  },
  addressBookSettingsPageView: {
    pageId: PAGE_IDS.addressBook,
    data: {
      event_category: myAccountCategory,
      event_type: `${myAccountCategory}/addressBook`,
    },
  },
  alternativeIdsRemoveClick: {
    ...alternativeIdsBaseData,
    eventId: 'Click remove id',
    eventLabel: 'Remove id',
  },
  alternativeIdsAddClick: {
    ...alternativeIdsBaseData,
    eventId: 'Click show add form',
    eventLabel: 'Add new id',
  },
  alternativeIdsAddPhoneClick: {
    ...alternativeIdsBaseData,
    eventId: 'Submit new id',
    eventLabel: 'phone',
  },
  alternativeIdsAddSsnClick: {
    ...alternativeIdsBaseData,
    eventId: 'Submit new id',
    eventLabel: 'ssn',
  },
  alternativeIdsAddSuccess: {
    id: 'alternativeIdsAddSuccess',
    data: {
      ...baseAccountClickData,
      event_type: 'ALTERNATIVE_ID',
      event_id: 'Submit success',
      event_label: 'Submit success',
    },
  },
  alternativeIdsAddFail: {
    id: 'alternativeIdsAddFail',
    data: {
      ...baseAccountClickData,
      event_type: 'ALTERNATIVE_ID',
      event_id: 'Submit fail',
      event_label: 'Submit fail',
    },
  },
  memberCardAltIdLinkClick: {
    ...alternativeIdsBaseData,
    eventId: 'Click member info card link',
    eventLabel: 'Member info card link',
  },
  copyInviteLink: {
    id: 'copyInviteLink',
    data: {
      event_type: 'COPY_INVITE_FRIEND_LINK',
      event_category: 'Club',
      event_id: 'Invite a friend',
      event_label: 'Copy invite link',
    },
  },
  showMemberID: {
    id: 'showMemberID',
    data: {
      ...baseAccountClickData,
      event_id: 'showMemberId',
      event_type: `${myAccountCategory}/showMemberId`,
    },
  },
  viewReward: {
    id: 'viewReward',
    data: {
      ...baseAccountClickData,
      event_id: 'viewReward',
      event_type: `${myAccountCategory}/viewReward`,
    },
  },
  deleteAccountPageView: {
    id: 'deleteAccountPageView',
    data: {
      page_id: PAGE_IDS.deleteAccountPage,
    },
  },
  clickLeaveModalTrigger: {
    id: 'clickLeaveModalTrigger',
    data: {
      event_category: 'Click leave modal clicker',
      event_id: 'leaveClick',
      event_type: `${myAccountCategory}/deleteAccount/clickLeaveModalTrigger`,
    },
  },
  clickCloseModalTrigger: {
    id: 'clickCloseModalTrigger',
    data: {
      event_category: 'Click close modal clicker',
      event_id: 'closeClick',
      event_type: `${myAccountCategory}/deleteAccount/clickCloseModalTrigger`,
    },
  },
  clickWantToStayTrigger: {
    id: 'clickWantToStayTrigger',
    data: {
      event_category: 'Click want to stay clicker',
      event_id: 'wantToStayClick',
      event_type: `${myAccountCategory}/deleteAccount/wantToStayClick`,
    },
  },
  clickSubmitModalTrigger: {
    id: 'clickSubmitModalTrigger',
    data: {
      event_category: 'Click submit modal clicker',
      event_id: 'submitClick',
      event_type: `${myAccountCategory}/deleteAccount/clickSubmitModalTrigger`,
    },
  },
  clickOnlineOrdersTab: {
    ...myAccountBaseData,
    eventId: 'onlineOrdersList',
    eventType: `${myAccountCategory}/onlineOrdersList`,
  },
  clickStoreOrdersTab: {
    ...myAccountBaseData,
    eventId: 'inStorePurchasesList',
    eventType: `${myAccountCategory}/inStorePurchasesList`,
  },
  onlineOrdersListError: {
    id: 'onlineOrdersListError',
    data: {
      ...baseAccountClickData,
      event_id: 'onlineOrdersListError',
      event_type: `${myAccountCategory}/onlineOrdersListError`,
    },
  },
  newsError: {
    id: 'newsError',
    data: {
      ...baseAccountClickData,
      event_id: 'newsError',
      event_type: `${myAccountCategory}/newsError`,
    },
  },
  storeOrdersListError: {
    id: 'storeOrdersListError',
    data: {
      ...baseAccountClickData,
      event_id: 'inStorePurchasesListError',
      event_type: `${myAccountCategory}/inStorePurchasesListError`,
    },
  },
  onlineOrderDetailsError: {
    id: 'onlineOrderDetailsError',
    data: {
      ...baseAccountClickData,
      event_id: 'onlineOrderError',
      event_type: `${myAccountCategory}/onlineOrderError`,
    },
  },
  storeOrderDetailsError: {
    id: 'storeOrderDetailsError',
    data: {
      ...baseAccountClickData,
      event_id: 'inStorePurchaseError',
      event_type: `${myAccountCategory}/inStorePurchaseError`,
    },
  },
  clickOnlineOrderReceiptPDF: {
    ...myAccountBaseData,
    eventId: 'onlineOrderReceiptPDF',
    eventType: `${myAccountCategory}/onlineOrderReceiptPDF`,
  },
  clickStoreOrderReceiptPDF: {
    ...myAccountBaseData,
    eventId: 'inStorePurchaseReceiptPDF',
    eventType: `${myAccountCategory}/inStorePurchaseReceiptPDF`,
  },
  onlineReceiptPDFError: {
    id: 'onlineReceiptPDFError',
    data: {
      ...baseAccountClickData,
      event_id: 'onlineOrderReceiptPDFError',
      event_type: `${myAccountCategory}/onlineOrderReceiptPDFError`,
    },
  },
  inStoreReceiptPDFError: {
    id: 'inStoreReceiptPDFError',
    data: {
      ...baseAccountClickData,
      event_id: 'inStorePurchaseReceiptPDFError',
      event_type: `${myAccountCategory}/inStorePurchaseReceiptPDFError`,
    },
  },

  onFNBannerCTAClick: {
    ...myAccountBaseData,
    eventId: 'FNSubscribeClick',
    eventType: `${myAccountCategory}/FNSubscribeClick`,
  },

  onEditSubscriptionSaveClick: {
    ...myAccountBaseData,
    eventId: 'FNSubscribeSaveClick',
    eventType: `${myAccountCategory}/FNSubscribeSaveClick`,
  },

  // Rewards Tracking Events

  clickOffersTab: {
    ...myAccountBaseData,
    eventId: 'viewallrewardstabswitch',
    eventType: `${myAccountCategory}/offersTab`,
  },
  clickVouchersTab: {
    ...myAccountBaseData,
    eventId: 'viewallrewardstabswitch',
    eventType: `${myAccountCategory}/vouchersTab`,
  },

  viewOffersFromViewAll: {
    ...myAccountBaseData,
    event_id: 'viewrewardfromviewallofferspage',
    eventType: `${myAccountCategory}/viewrewardfromviewallofferspage`,
  },

  viewVouchersFromViewAll: {
    ...myAccountBaseData,
    event_id: 'viewrewardfromviewallvoucherspage',
    eventType: `${myAccountCategory}/viewrewardfromviewallvoucherspage`,
  },
  clickAddToBagVoucher: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/voucheraddtobag`,
    event_id: 'reward/voucheraddtobag',
  },
  clickAddToBagOffer: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/offeraddtobag`,
    event_id: 'reward/offeraddtobag',
  },
  clickVoucherRedeemStore: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/voucherredeematstore`,
    event_id: 'reward/voucherredeematstore',
  },
  clickOfferRedeemStore: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/offerredeematstore`,
    event_id: 'reward/offerredeematstore',
  },
  clickViewAllToVoucher: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/viewvoucherdetailspage`,
    event_id: 'reward/viewvoucherdetailspage',
  },
  clickViewAllToOffers: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/viewofferdetailspage`,
    event_id: 'reward/viewofferdetailspage',
  },
  clickRewardCarouselToVoucher: {
    ...myAccountBaseData,
    event_type: `${myAccountCategory}/reward/viewvoucherdetailspage`,
    event_id: 'reward/viewvoucherdetailspage',
  },

  viewVouchersFromCarousel: {
    ...myAccountBaseData,
    event_id: 'viewrewardvouchercarousel',
    eventType: `${myAccountCategory}/viewrewardvouchercarousel`,
  },

  viewOffersFromCarousel: {
    ...myAccountBaseData,
    event_id: 'viewrewardoffercarousel',
    eventType: `${myAccountCategory}/viewrewardoffercarousel`,
  },
  clubVoucherCTA: {
    event_type: 'CLUB_VOUCHER_CTA',
    event_category: 'Club',
    event_id: 'Voucher CTA',
  },
}
